var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isEqual } from 'lodash';
/** Get the value for value to value comparisons */
export var reduceValue = function (primaryKey) {
    var reduce = function (value) {
        return typeof value !== 'object' ? value : value === null || value === void 0 ? void 0 : value[primaryKey];
    };
    return reduce;
};
export var flattenOptionsArray = function (optionsArray, primaryKey) {
    var reduce = reduceValue(primaryKey);
    var optionIndexMap = new Map();
    var flattenedOptions = [];
    var optionsIndex = -1;
    for (var i = 0; i < optionsArray.length; i++) {
        var item = optionsArray[i];
        optionsIndex += 1;
        if (item.groupId && item.options) {
            var label = item.label, groupId = item.groupId, options = item.options, groupOther = __rest(item, ["label", "groupId", "options"]);
            var returnArray = [];
            var headerObj = __assign({ header: true, label: label, groupId: groupId, optionsIndex: optionsIndex, selected: false }, groupOther);
            options ? returnArray.push(headerObj) : null;
            optionIndexMap.set(item.label + ' - ' + item.groupId, optionsIndex);
            if (options === null || options === void 0 ? void 0 : options.length) {
                // changing to for loop here for speed in large lists
                var groupArr = [];
                for (var i_1 = 0; i_1 < options.length; i_1++) {
                    var _a = options[i_1], label_1 = _a.label, value = _a.value, disabled = _a.disabled, isFixed = _a.isFixed, other = __rest(_a, ["label", "value", "disabled", "isFixed"]);
                    optionsIndex += 1;
                    groupArr.push(__assign(__assign(__assign(__assign({}, (disabled && { disabled: disabled })), (isFixed && { isFixed: isFixed })), { label: label_1, value: value, groupId: groupId, optionsIndex: optionsIndex, selected: false }), other));
                    optionIndexMap.set("".concat(label_1, " - ").concat(value ? reduce(value) : ''), optionsIndex);
                }
                returnArray = __spreadArray(__spreadArray([], returnArray, true), groupArr, true);
            }
            flattenedOptions = __spreadArray(__spreadArray([], flattenedOptions, true), returnArray, true);
        }
        else {
            flattenedOptions.push(__assign(__assign({}, item), { optionsIndex: i, selected: false }));
            optionIndexMap.set("".concat(item.label, " - ").concat(item.value ? reduce(item.value) : ''), i);
        }
    }
    return {
        flattenedOptions: flattenedOptions.length
            ? flattenedOptions
            : [{ empty: true, label: 'No Results Found', value: 'No Results Found' }],
        optionIndexMap: optionIndexMap,
    };
};
/** get original index of where the option is in the original options array
 * sort it low to high to ensure proper placement
 * @param flattenedOptions the original array we want to compare to
 * @param value  the new value array to sort
 */
export var getValueFromFlatArray = function (flattenedOptions, optionIndexMap, value, primaryKey) {
    var reduce = reduceValue(primaryKey);
    if (!Array.isArray(value)) {
        // Not multi-select
        var returnVal = void 0;
        if (!value || value.disabled)
            return;
        returnVal = flattenedOptions.filter(function (opt) {
            if (value.groupId) {
                // NOTE: This casting should be safe because the boolean will weigh out falsy if needed, should be fixed one day though
                return (reduce(opt.value) === reduce(value.value) &&
                    opt.label === value.label &&
                    value.groupId === opt.groupId);
            }
            return reduce(opt.value) === reduce(value.value) && opt.label === value.label;
        })[0];
        if (returnVal) {
            returnVal = __assign(__assign({}, returnVal), { selected: true });
        }
        return returnVal;
    }
    // multi-select...
    // If all are selected, no need to loop; just return it all
    // We are not returning flattenedOptions when the length is 1 since we are currently providing the "No results found"
    //  as a flattenedOption and returning that with one pre-selected option causes the tag to disappear.
    if (flattenedOptions.length !== 1 && isEqual(flattenedOptions, value)) {
        return flattenedOptions;
    }
    var sortedPropsValue = value
        .filter(function (x) { return x; })
        .map(function (x) { return (__assign(__assign({}, x), { optionsIndex: optionIndexMap.get(x.label + ' - ' + reduce(x.value)), selected: true })); });
    return sortedPropsValue;
};
